/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */

import React from "react";
import { ScrollView } from "react-native";

import { logEvent } from "firebase/analytics";
import { analytics } from "../../App/Analytics";

import {
  NonRecursivePostCard,
  NonRecursivePostCardConfig,
  nonRecursivepostCardConfigDemo2TextBubble,
  nonRecursivePostCardConfigDemo1TawkPill,
} from "../NonRecursivePostCard/NonRecursivePostCard";

import "./PostCard.css";

export interface PostCardConfig {
  primaryPostConfig: NonRecursivePostCardConfig;
  derivativePostConfigs: NonRecursivePostCardConfig[];
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  analyticsParams: { [key: string]: any };
  /* eslint-enable  @typescript-eslint/no-explicit-any */
}

export const postCardConfigDemo1TawkPill: PostCardConfig = {
  primaryPostConfig: nonRecursivePostCardConfigDemo1TawkPill,
  derivativePostConfigs: [nonRecursivepostCardConfigDemo2TextBubble],
  analyticsParams: {},
};

export const postCardConfigDemo2TextBubble: PostCardConfig = {
  primaryPostConfig: nonRecursivePostCardConfigDemo1TawkPill,
  derivativePostConfigs: [nonRecursivepostCardConfigDemo2TextBubble],
  analyticsParams: {},
};

function DerivativePosts(props: PostCardConfig): JSX.Element {
  const derivativePosts = props.derivativePostConfigs.map(
    (derivativePostConfig) => (
      <div className="primary-post-individual-derivative-post">
        <NonRecursivePostCard {...derivativePostConfig} />
      </div>
    )
  );

  const scrollViewRef = React.createRef<ScrollView>();
  const scrollView = (
    <ScrollView
      showsHorizontalScrollIndicator={false}
      horizontal
      ref={scrollViewRef}
    >
      <div className="derivative-posts-scroller-prefix-spacer" />
      {derivativePosts}
    </ScrollView>
  );

  return scrollView;
}

export function PostCard(props: PostCardConfig): JSX.Element {
  logEvent(analytics, "post_card_view", {
    firebase_screen: "PostCard",
    firebase_screen_class: "PostCard",
    ...props.analyticsParams,
  });

  return (
    <div className="post-card">
      <div
        className="post-card-internal"
        style={
          {
            // gap: "10px",
          }
        }
      >
        <div className="primary-post-card">
          <NonRecursivePostCard {...props.primaryPostConfig} />
        </div>

        <div className="primary-post-derivative-posts">
          <DerivativePosts {...props} />
        </div>
      </div>
    </div>
  );
}
